module.exports = __webpack_public_path__ + "media/images/weather/43_day-2f7f83be54faf949ed0da5b42ab79b3b.png";